export enum SuccessHandToHandButtonToken {
  SendContactRequest = 'send-contact-request-modal',
  Info = 'info-modal',
}
